import react, { useLayoutEffect, useRef, useState } from 'react';
import MemeVideoModal from './MemeVideoModal'; // your modal component

const MemeVideos = () => {

  const video1Ref = useRef(null);
  const video2Ref = useRef(null);

  const [modalVideo, setModalVideo] = useState(null);

  const isMobile = () => window.innerWidth <= 768;

  useLayoutEffect(() => {
    const register = (video, id) => {
      if (!video) return;
      video.volume = 0.5;
      const handle = () => {
        if (isMobile()) {
          const req = video.requestFullscreen || video.webkitRequestFullscreen || video.msRequestFullscreen;
          req?.call(video);
          video.play();
        } else {
          setModalVideo(id);
        }
      };
      video.addEventListener('click', handle);
      return () => video.removeEventListener('click', handle);
    };
    const cleanup1 = register(video1Ref.current, 1);
    const cleanup2 = register(video2Ref.current, 2);
    return () => {
      cleanup1?.();
      cleanup2?.();
    };
  }, []);

  return (
    <>
      <MemeVideoModal
        open={modalVideo !== null}
        onClose={() => setModalVideo(null)}
        videoId={modalVideo}
      />
      <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
        <div className="video-wrapper">
          <video id="meme-video-2" 
            className="meme-video" 
            ref={video2Ref}
            poster="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-guide-peer-brother.webp">
            <source src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/meme-video-2.mp4" type="video/mp4" />
          </video>
        </div>
        <div className="video-wrapper">
          <video 
          id="meme-video-1" 
          className="meme-video" 
          ref={video1Ref}
          poster="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-guide-peer-sister.webp">
            <source src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/meme-video-1.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </>
  );
}

export default MemeVideos;